import { Map } from 'mapbox-gl';

/**
 * A class that represents a custom Mapbox GL button control.
 */
export type Positions = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
export type EventHandler = (map: Map, event: MouseEvent) => any;

export default class MapboxButtonControl {
    readonly className: string;
    readonly title: string;
    readonly iconPath: string;
    readonly position: Positions;
    readonly eventHandler: EventHandler;

    private container?: HTMLElement;
    private map?: Map;

    constructor(
        className: string,
        title: string,
        iconPath: string,
        position: Positions,
        eventHandler: EventHandler,
    ) {
        this.className = className;
        this.title = title;
        this.iconPath = iconPath;
        this.position = position;
        this.eventHandler = eventHandler;
    }

    onAdd(map: Map): HTMLElement {
        this.map = map;

        this.container = document.createElement('div');
        this.container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';

        const button = document.createElement('button');
        button.className = `mapboxgl-ctrl-icon ${this.className}`;
        button.type = 'button';
        button.title = this.title;
        button.style.background = `url(${this.iconPath}) no-repeat center`;
        button.onclick = (event: MouseEvent) => this.eventHandler(map, event);

        this.container.appendChild(button);

        return this.container;
    }

    onRemove() {
        if (this.container && this.container.parentNode) {
            this.container.parentNode.removeChild(this.container);
        }
        this.map = undefined;
    }
}
